import { apiAxios } from '../utils/request.js'
// 图片分页
export const imagePage = (data, Istoast = false, Send = false) => {
  return apiAxios('post', '/shopapi/gallery/image/page', data, Istoast, Send)
}
// 标签列表
export const tagList = (data, Istoast = false, Send = false) => {
  return apiAxios('post', '/shopapi/gallery/tag/list', data, Istoast, Send)
}
